import { createTheme } from "@material-ui/core";

export default createTheme({
  palette: {
    primary: {
      main: "#F01345",
    },
  },
});
